module.exports = wdg.blocks.panelsViewScript;